import {
  combineReducers
} from 'redux'
import {
  PLACE,
  POPULAR_PLACE,
  PLACE_DETAILS
} from '../../actions/actionTypes'
import {
  fetchingData,
  initStateLang
} from '../../utils'

const initailState = {
  loading: false,
  error: '',
  data: [],
  lastUpdate: ''
}

const list = (state = initStateLang(initailState, ['data', 'lastUpdate']), action) => {
  switch (action.type) {
    case PLACE.REQUEST:
    return {
      ...state,
      loading: true,
      error: '',
      [action.lang]: { data: [] }
    }
  case PLACE.SUCCESS:
    return {
      ...state,
      loading: false,
      error: '',
      [action.lang]: { data: action.data, lastUpdate: action.lasted }
    }
  case PLACE.FAILURE:
    return {
      ...state,
      loading: false,
      error: action.error,
    }
  default:
    return state
  }
}
const popular = (state = initStateLang(initailState, ['data', 'lastUpdate']), action) => {
  switch (action.type) {
    case POPULAR_PLACE.REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
        [action.lang]: { data: [] }
      }
    case POPULAR_PLACE.SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        [action.lang]: { data: action.data, lastUpdate: action.lasted }
      }
    case POPULAR_PLACE.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      }
    default:
      return state
  }
}
const initailStateDetail = {
  loading: false,
  error: '',
  data: {},
  lastUpdate: ''
}
const details = (state = initStateLang(initailStateDetail, ['data', 'lastUpdate']), action) => {
  switch (action.type) {
    case PLACE_DETAILS.REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
        [action.lang]: { data: {} }
      }
    case PLACE_DETAILS.SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        [action.lang]: { data: action.data, lastUpdate: action.lasted }
      }
    case PLACE_DETAILS.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      }
    default:
      return state
  }
}
export default combineReducers({
  list,
  popular,
  details
})


// WEBPACK FOOTER //
// ./src/containers/Place/reducer.js